import * as THREE from 'three'

import shaderFragment from '../../shaders/ground/fragment.glsl'
import shaderVertex from '../../shaders/ground/vertex.glsl'

export default function()
{
    return new THREE.ShaderMaterial({
        uniforms: {
            uTopLeft: { value: new THREE.Color('#f5883c') },
            uTopRight: { value: new THREE.Color('#ff9043') },
            uBottomRight: { value: new THREE.Color('#fccf92') },
            uBottomLeft: { value: new THREE.Color('#f5aa58') }
        },
        vertexShader: shaderVertex,
        fragmentShader: shaderFragment
    })
}
